// extracted by css-extract-rspack-plugin
export default {"wrapper":"Integrations_wrapper__fDt2f"};